import { render, staticRenderFns } from "./TempSwitch.vue?vue&type=template&id=ce7412da&scoped=true&"
import script from "./TempSwitch.vue?vue&type=script&lang=js&"
export * from "./TempSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TempSwitch.vue?vue&type=style&index=0&id=ce7412da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7412da",
  null
  
)

export default component.exports